import React from 'react';

type LoaderSize = 'small' | 'large';

export interface LoaderProps {
  size: LoaderSize;
}

const sizeStyles: Record<LoaderSize, React.CSSProperties> = {
  small: { width: 24, height: 24, border: '3px solid #e5e7eb', borderTopColor: '#1f2937' },
  large: { width: 48, height: 48, border: '4px solid #e5e7eb', borderTopColor: '#1f2937' },
};

export const Loader: React.FC<LoaderProps> = ({ size }) => (
  <div
    data-testid="loader"
    style={{
      borderRadius: '50%',
      boxSizing: 'border-box',
      animation: 'od-loader-spin 0.8s linear infinite',
      ...sizeStyles[size],
    }}
  />
);
